import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3">
            内容分类
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            探索体育世界
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            六大内容板块，全方位覆盖您关心的体育领域
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 whitespace-nowrap">{cat.name}</h3>
                <p className="text-foreground-400 text-xs mt-1">{cat.count}篇文章</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}